import React from 'react';
import { ImageBlock } from '../../ast/document.types';
import { ImageIcon } from 'lucide-react';

interface ImageBlockRendererProps {
  block: ImageBlock;
}

export const ImageBlockRenderer: React.FC<ImageBlockRendererProps> = ({ block }) => {
  const { previewDataUrl, caption, altText, widthPercent = 80, alignment = 'center', opacity = 1, rotation = 0, offsetX = 0, offsetY = 0 } = block.data;

  const getAlignmentStyle = (): React.CSSProperties => {
    switch (alignment) {
      case 'left':
        return { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' };
      case 'right':
        return { display: 'flex', flexDirection: 'column', alignItems: 'flex-end' };
      case 'center':
      default:
        return { display: 'flex', flexDirection: 'column', alignItems: 'center' };
    }
  };

  return (
    <div
      style={{
        margin: '14px 0',
        ...getAlignmentStyle(),
        transform: `translate(${offsetX}px, ${offsetY}px)`,
        transition: 'transform 0.05s ease-out',
      }}
    >
      {previewDataUrl ? (
        <img
          src={previewDataUrl}
          alt={altText || caption || 'Report Figure'}
          style={{
            width: `${widthPercent}%`,
            maxHeight: '400px',
            objectFit: 'contain',
            borderRadius: 'var(--radius-xs)',
            border: '1px solid #e5e7eb',
            opacity,
            transform: rotation ? `rotate(${rotation}deg)` : undefined,
          }}
        />
      ) : (
        <div
          style={{
            width: `${widthPercent}%`,
            height: '140px',
            backgroundColor: '#f3f4f6',
            border: '1px dashed #9ca3af',
            borderRadius: 'var(--radius-xs)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#6b7280',
            gap: 6,
          }}
        >
          <ImageIcon size={24} />
          <span style={{ fontSize: '11px' }}>Image Placeholder ({widthPercent}%)</span>
        </div>
      )}

      {caption && (
        <div style={{ fontSize: '11px', color: '#4b5563', fontStyle: 'italic', marginTop: '6px' }}>
          {caption}
        </div>
      )}
    </div>
  );
};
